import { resolveSegmentFramesIfGap } from '@com/components/timeline-panel/utils/segment'
import { IvSegment } from '@ps/store/interactive-video/timeline/types'

export { findVideoSegmentFromTracks } from '@ps/store/interactive-video/timeline/utiles/scene'

export const getScopedStart = (
  scopeSegment: IvSegment | null,
  target: IvSegment,
): IvSegment['start'] => {
  const maxX = Math.min(
    target.start,
    scopeSegment
      ? scopeSegment.start +
          scopeSegment.frames -
          resolveSegmentFramesIfGap(target)
      : target.start,
  )

  return Math.max(scopeSegment?.start ?? 0, maxX)
}
